var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "-0.5 0.5 42 42",
    fill: "#0a56d9",
    xmlSpace: "preserve",
    transform: "scale(-1 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 30.49v8.996c0 1.217.938 1.045 1.25.795.384-.308 10.75-9.791 10.75-9.791h13c2.471 0 3-.529 3-2.999V6.859c0-2.899-.5-3.359-3-3.359h-32c-2.46 0-3 .5-3 2.999v20.992c0 2.429.42 2.999 3 2.999zm2.26-11.496c0 1.52-1.24 2.759-2.76 2.759s-2.76-1.239-2.76-2.759 1.24-2.759 2.76-2.759 2.76 1.241 2.76 2.759m9 0c0 1.52-1.24 2.759-2.76 2.759a2.765 2.765 0 0 1-2.76-2.759A2.765 2.765 0 0 1 20 16.235c1.52 0 2.76 1.241 2.76 2.759m9 0c0 1.52-1.24 2.759-2.76 2.759s-2.76-1.239-2.76-2.759 1.24-2.759 2.76-2.759 2.76 1.241 2.76 2.759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.cca9f9946c03e9aaacc53ebe237e8bd9.svg";
export { ForwardRef as ReactComponent };